import { createContext, useState, useContext, useMemo, useEffect } from 'react';

import { UserContextValue, UserProviderProps, User } from './UserContext.types';
import { getAvatarSrc, isAuthorizedByBlackbox } from './UserContext.helpers';

const UserContext = createContext<UserContextValue | undefined>(undefined);

export const UserProvider = ({ children }: UserProviderProps) => {
    // При SSR считаем пользователя авторизованным с данными по умолчанию
    const [user, setUser] = useState<User>({
        isAuth: true,
        login: 'login',
        firstName: 'Имя',
        lastName: 'Фамилия',
        avatarSrc: getAvatarSrc(),
    });

    // При гидратации получаем реальные данные пользователя из window.__BLACKBOX_DATA__
    useEffect(() => {
        if (window.__BLACKBOX_DATA__) {
            const blackboxData = window.__BLACKBOX_DATA__;

            if (!isAuthorizedByBlackbox(blackboxData)) {
                setUser({ isAuth: false });

                return;
            }

            setUser({
                isAuth: true,
                login: blackboxData.login,
                firstName: blackboxData.firstName,
                lastName: blackboxData.lastName,
                avatarSrc: getAvatarSrc(blackboxData.avatar),
                uid: blackboxData.uid,
            });
        }
    }, []);

    const value: UserContextValue = useMemo(() => ({ user }), [user]);

    return <UserContext.Provider value={value}>{children}</UserContext.Provider>;
};

export const useUserContext = (): UserContextValue => {
    const context = useContext(UserContext);

    if (context === undefined) {
        throw new Error('useUserContext must be used within a UserProvider');
    }

    return context;
};
